import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-rel"]




export default /*#__PURE__*/_defineComponent({
  __name: 'BannerImage',
  props: {
  bannerUrl: {
    type: String,
    required: true
  },
  activeTab: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    style: _normalizeStyle('background-image: url(' + __props.bannerUrl + ');'),
    id: "home-banner",
    class: "auction-content active h-100 top-banner child-site-banner lazy-loaded",
    "data-rel": __props.activeTab
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 12, _hoisted_1))
}
}

})